import Agreement_Minimal from './Agreement_Minimal'

export default {
    Agreement_Minimal,
}
